module.exports = __webpack_public_path__ + "ca.svg?a3999867cb776b04ebddf5d9eef4f48c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ca.svg
// module id = 1285
// module chunks = 0